import * as ReactRedux from 'react-redux';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import PosSaleResultComponent from './PosSaleResultComponent';
import { AppState } from '../app/app.types';
import { emailReceipt } from './Actions';

const mapDispatchToProps = (dispatch) => {
  return {
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toPosSale: () => dispatch(push(paths.posSale)),
    toPosHistory: () => dispatch(push(paths.posHistory)),
    emailReceipt: (entityId: number) => dispatch(emailReceipt(entityId))
  };
};

const mapStateToProps = (state: AppState, ownProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    businessState: state.businessState,
    posState: state.posState
  };
};

const PosSaleResult = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PosSaleResultComponent);

export default PosSaleResult;


// WEBPACK FOOTER //
// ./src/pos/PosSaleResult.tsx